import { ProjectDto } from '@admin/models/project-dto';
import { ProjectActions, ProjectActionTypes } from '@app/core/store/actions/project.action';
import { ProjectUserReportDto } from '@app/generated/model';

export interface ProjectState {
  projects: ProjectDto[];
  currentProject: ProjectDto | null;
  filter: string;
  isLoading: boolean;
  userReport: ProjectUserReportDto[];
  userReportLoading: boolean;
  userReportFilter: string;
}

export const initialState: ProjectState = {
  projects: [],
  currentProject: null,
  filter: '',
  isLoading: false,
  userReport: [],
  userReportLoading: false,
  userReportFilter: '',
};

export function projectReducer(state: ProjectState = initialState, action: ProjectActions): ProjectState {
  switch (action.type) {
    case ProjectActionTypes.LoadProjects:
      return { ...state, isLoading: true };
    case ProjectActionTypes.LoadProjectsSuccess:
      return { ...state, projects: action.projects, isLoading: false };
    case ProjectActionTypes.LoadProject:
      return { ...state, currentProject: null };
    case ProjectActionTypes.LoadProjectSuccess:
      return { ...state, currentProject: action.project };
    case ProjectActionTypes.FilterProjects:
      return { ...state, filter: action.filter };
    case ProjectActionTypes.LoadProjectUserReport:
      return { ...state, userReportLoading: true };
    case ProjectActionTypes.LoadProjectUserReportSuccess:
      return { ...state, userReport: action.report, userReportLoading: false };
    case ProjectActionTypes.FilterStatistics:
      return { ...state, userReportFilter: action.filter };
    default:
      return state;
  }
}
